import router from '../../router'

export function openCallBackModal(props) {
  // temporary hide modals for pages
  const excludePages = ['home', 'vacancies', 'vacancy'];
  const excludePagesDoubled = excludePages.concat(excludePages.map(v => v + '-double'));
  if (excludePagesDoubled.includes(router.currentRoute.name)) return false;

  this.$vModal.open('call-back', props);

  return true;
}
